//Base URL
const baseURL = process.env.REACT_APP_API_URL || "http://localhost:3001/";

//handle email sending
const sendEmail = "send-email";

// OTP request and verification
const forgotPassword = "forgot-password"; //reguest otp for forgot password
const verifyEmail = "verify-email"; // request otp for email during registration
const validateOTP = "validate-otp";

//reset password
const resetPassword = "reset-password";

//Authentication and authorization
const register = "register";
const authenticate = "auth";
const refresh = "refresh";
const logout = "logout";

//session check
const refreshTokenExpiryEP = "refresh-token-expiry";
const validateSession = "validate-session";

//Authorized actions for projects
const project = "project"; //POST, PUT, DELETE. GET, GET BY ID
const addfiles = "upload-files";

//insta and git links
const insta = process.env.REACT_APP_INSTAGRAM_URL ?? "";
const git = process.env.REACT_APP_GITHUB_URL ?? "";

export {
  baseURL,
  sendEmail,
  forgotPassword,
  verifyEmail,
  validateOTP,
  resetPassword,
  register,
  authenticate,
  refresh,
  logout,
  refreshTokenExpiryEP,
  validateSession,
  project,
  addfiles,
  insta,
  git
};
